import { Icons } from "assets/icons";
import NoDataFound from "components/common/NoDataFound";
import { CustomerMembershipStatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import TableShimmer from "components/common/TableShimmer";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getMemberships } from "store/slices/customersSlice";
import { PLAN_TYPES } from "utils/constants";
import { CurrencySymbol, formatUTCDate } from "utils/utils";

const Membership = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading2, memberships } = useSelector((state) => state.Customers);

  const { noMembership } = Icons || {};

  useEffect(() => {
    dispatch(getMemberships(id));
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Membership No.",
        key: "membershipNo",
      },
      {
        header: "Plan Name",
        key: "planId",
        render: (value) => value?.title?.en,
      },
      {
        header: "Plan Type",
        key: "planType",
        render: (value) =>
          PLAN_TYPES?.find((option) => option?.value === value)?.name || "-",
      },
      {
        header: "License Plate",
        key: "userVehicleId",
        render: (value) => value?.licencePlateNumber || "-",
      },
      {
        header: "Amount",
        key: "finalPrice",
        render: (value) => (
          <p className="price_symbol">
            <CurrencySymbol width="12" height="14" />
            {value}
          </p>
        ),
      },
      {
        header: "Usage",
        key: "usage",
        render: (value) => value?.totalUses,
      },
      {
        header: "Status",
        key: "status",
        render: (value) => (
          <CustomerMembershipStatusBadge status={value} t={t} />
        ),
      },
      {
        header: "Billing Cycle Start",
        key: "billingCycleStart",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: "Billing Cycle End",
        key: "billingCycleEnd",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: "Created Date",
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
    ],
    [t]
  );

  return (
    <div>
      {loading2 && <TableShimmer rows={12} columns={8} />}
      {!loading2 && memberships?.length === 0 && (
        <NoDataFound title={t("No memberships found")} icon={noMembership} />
      )}
      {!loading2 && memberships?.length > 0 && (
        <>
          <DataTable columns={columns} data={memberships} t={t} />
        </>
      )}
    </div>
  );
};

export default Membership;
